import { Platform } from "react-native";

// Teams: people working in someone else's account with their own sign-in
// (audits/team-access-plan-2026-10/PLAN.md).
// - On the web it's live. Business accounts manage their team (Profile ›
//   Team, an event › People); anyone invited can accept and switch accounts,
//   whatever their own account type. Which owners Teams works for is the
//   server's call (eventlive-cdk/teams, /eventlive/teams/beta-owners).
// - The iOS and Android apps have it from the first store build with this
//   code. A build can leave it out with EXPO_PUBLIC_TEAMS_UI=false. Invite
//   links open the web app (app.eventlive.pro/invite/…); once accepted, the
//   account shows in the app's Profile › Accounts and "Shared with you".
export function teamsUiEnabled({ os, env } = {}) {
  if (os === "web") return true;
  return (os === "ios" || os === "android") && env !== "false";
}

function readFlag() {
  // Literal process.env.EXPO_PUBLIC_*: Expo inlines it at build time.
  return teamsUiEnabled({
    os: Platform.OS,
    env: process.env.EXPO_PUBLIC_TEAMS_UI,
  });
}

export const TEAMS_UI_ENABLED = readFlag();

// Who has a team of their own to manage: business accounts (PLAN.md §5.5).
// In someone else's account, the role decides (manageTeam).
export const hasOwnTeam = (accountType) => accountType === "business";
